export default {
    computed: {
        formattedTIN() {
            return this.tin
                .replace(/\D/g, '') // remove non-digits
                .replace(/^(\d{3})(\d{3})?(\d{3})?(\d{0,5})?/, (match, p1, p2, p3, p4) => {
                    let result = p1;
                    if (p2) result += '-' + p2;
                    if (p3) result += '-' + p3;
                    if (p4) result += '-' + p4;
                    return result;
                });
        }
    },
    methods: {
        formatTIN(value) {
            this.tin = value.replace(/\D/g, '').slice(0, 14); // Max 14 digits
        },
        formatNumberComma(value) {
            if (!value && value !== 0) return '';
            const parts = value.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        },
        parseNumber(value) {
            const cleaned = value.replace(/[^0-9.]/g, '');
            const parts = cleaned.split('.');
            // Keep only one decimal point
            if (parts.length > 2) {
                return parseFloat(parts[0] + '.' + parts[1]);
            }
            return cleaned;
        },
        formatNumber(number) {
            if (number == null || isNaN(number)) {
                return '';
            }
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(number);
        }
    }
};
